import { InjectionToken } from '@angular/core';
import { CtrlMessageProvider } from '../models/ctrl-message-provider';

export const CTRL_MESSAGE_PROVIDER: InjectionToken<CtrlMessageProvider> =
  new InjectionToken<CtrlMessageProvider>('CTRL_MESSAGE_PROVIDER');
